import React from 'react';
import './Tablecss.css';

const Tablepnl = () => {
    // Sample data that matches your table structure
    const projectData = [
        {
            project: "Demo Project",
            invoicePayment: {
                raised: 10000,
                received: 8000,
                difference: 2000
            },
            expenses: {
                employeeSalary: 1000,
                vehicleBilling: 1000,
                officeRent: 1000,
                imprest: 1000,
                expenses: 1000,
                miscExpenses: 1000,
                travelCost: 1000,
                totalCost: 7000
            },
            projectAmendments: {
                eot: "123 days",
                cos: 4000
            },
            pendingLetters: {
                showCause: 10,
                informative: 20,
                drawing: 30,
                total: 60
            },
            employeeVacency: {
                vacency1: 2,
                vacency2: 3,
                vacency3: 1,
                total: 6
            },
            budgetVsActual: {
                budgeted: 2000,
                actual: 1000,
                difference: 1000
            },
            total: 23000,
            profitLoss: 3000,
            profitLossPercentage: "15%"
        },
        {
            project: "Demo2 Project",
            invoicePayment: {
                raised: 10000,
                received: 8000,
                difference: 2000
            },
            expenses: {
                employeeSalary: 1000,
                vehicleBilling: 1000,
                officeRent: 1000,
                imprest: 1000,
                expenses: 1000,
                miscExpenses: 1000,
                travelCost: 1000,
                totalCost: 7000
            },
            projectAmendments: {
                eot: "123 days",
                cos: 4000
            },
            pendingLetters: {
                showCause: 10,
                informative: 20,
                drawing: 30,
                total: 60
            },
            employeeVacency: {
                vacency1: 2,
                vacency2: 3,
                vacency3: 1,
                total: 6
            },
            budgetVsActual: {
                budgeted: 2000,
                actual: 1000,
                difference: 1000
            },
            total: 23000,
            profitLoss: 3000,
            profitLossPercentage: "15%"
        }
        // More projects can be added here
    ];

    const buffer = false; // Simulating no loading

    // Format currency with commas (Indian style)
    const formatCurrencyIndian = (amount) => {
        if (amount === undefined || amount === null) return "-";
        return amount.toLocaleString('en-IN', {
            maximumFractionDigits: 0,
            style: 'currency',
            currency: 'INR'
        }).replace('₹', '₹ ');
    };

    return (



        <div className="table-box">
            <table className="table-css">
                <thead className="table-heading">
                    <tr className="custom-table-head-tr">
                        <th className="table-heading">Sno.</th>
                        <th className="table-heading text-center">Project</th>
                        <th className="table-heading text-center">Invoice Payment</th>
                        <th className="table-heading">Expenses</th>
                        <th className="table-heading">Project Amendments</th>
                        <th className="table-heading">Pending Letters</th>
                        <th className="table-heading text-center">Emp. Vacancy</th>
                        <th className="table-heading text-center">Budgeted Vs Actual</th>
                        <th className="table-heading text-center">Total</th>
                        <th className="table-heading text-center">Profit or Loss</th>
                        <th className="table-heading text-center">Profit or Loss Percentage</th>
                    </tr>
                </thead>

                {buffer ? (
                    <div className="spinner-bgdatil">Loading...</div>
                ) : (
                    <tbody>
                        {projectData.map((project, index) => (
                            <React.Fragment key={index}>
                                {/* <tr className="spacer-row">
                                    <td colSpan="11"></td>
                                </tr> */}
                                <tr className="custom-table-head-td">
                                    <td className="table-body">{index + 1}</td>

                                    <td className="table-body project-cell">
                                        <div className="project-name">{project.project}</div>
                                    </td>


                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>Raised</td>
                                                    <td className="align-right highlight-blue">
                                                        {formatCurrencyIndian(project.invoicePayment.raised)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Received</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.invoicePayment.received)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Difference</td>
                                                    <td className={`align-right ${project.invoicePayment.difference > 0 ? 'highlight-red' : 'highlight-green'
                                                        }`}>
                                                        {formatCurrencyIndian(project.invoicePayment.difference)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>

                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>Employee Salary</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.employeeSalary)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Vehicle Billing</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.vehicleBilling)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Office Rent</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.officeRent)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Imprest</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.imprest)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Expenses</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.expenses)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Misc. Expenses</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.miscExpenses)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Travel Cost</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.expenses.travelCost)}
                                                    </td>
                                                </tr>
                                                <tr className="total-row">
                                                    <td>Total Cost</td>
                                                    <td className="align-right highlight-blue">
                                                        {formatCurrencyIndian(project.expenses.totalCost)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>


                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>EOT</td>
                                                    <td className="align-right">
                                                        {project.projectAmendments.eot}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>COS</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.projectAmendments.cos)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>


                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>show-cause</td>
                                                    <td className="align-right">
                                                        {project.pendingLetters.showCause}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>informative</td>
                                                    <td className="align-right">
                                                        {project.pendingLetters.informative}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Drawing</td>
                                                    <td className="align-right">
                                                        {project.pendingLetters.drawing}
                                                    </td>
                                                </tr>
                                                <tr className="total-row">
                                                    <td>Total</td>
                                                    <td className="align-right highlight-blue">
                                                        {project.pendingLetters.total}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>


                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>Vacancy 1</td>
                                                    <td className="align-right">
                                                        {project.employeeVacency.vacency1}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Vacancy 2</td>
                                                    <td className="align-right">
                                                        {project.employeeVacency.vacency2}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Vacancy 3</td>
                                                    <td className="align-right">
                                                        {project.employeeVacency.vacency3}
                                                    </td>
                                                </tr>
                                                <tr className="total-row">
                                                    <td>Total</td>
                                                    <td className="align-right highlight-blue">
                                                        {project.employeeVacency.total}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>


                                    <td className="table-body">
                                        <table className="inner-table">
                                            <tbody>
                                                <tr>
                                                    <td>Budgeted</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.budgetVsActual.budgeted)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Actual</td>
                                                    <td className="align-right">
                                                        {formatCurrencyIndian(project.budgetVsActual.actual)}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Difference</td>
                                                    <td className={`align-right ${project.budgetVsActual.difference > 0 ? 'highlight-green' : 'highlight-red'
                                                        }`}>
                                                        {formatCurrencyIndian(project.budgetVsActual.difference)}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>


                                    <td className="table-body total-cell text-center">
                                        {formatCurrencyIndian(project.total)}
                                    </td>

                                    <td className="table-body text-center" >
                                        <span className={`${project.profitLoss > 0 ? 'highlight-green' : 'highlight-red'
                                            }`}>  {formatCurrencyIndian(project.profitLoss)}</span>

                                    </td>


                                    <td className="table-body text-center">
                                        <span className={`${project.profitLoss > 0 ? 'highlight-green' : 'highlight-red'
                                            }`}>  {project.profitLossPercentage} </span>
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                )}
            </table>
        </div>



    );
};

export default Tablepnl;